<template>
  <v-card class="mx-auto overflow-visible " width="1000px" style="margin-top: 0px; margin-bottom: 0px;" outlined>
    <v-list-item three-line>
      <v-list-item-content class="overflow-visible">
        <v-container>
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <common-range-time-picker
                  :clearable="true"
                  :aLight="'right'"
                  :class="this.currentPicker === 4 ? 'show-date' : 'hide-date'"
                  label="Ngày giờ chuyển *"
                  placeholder="Chọn ngày giờ chuyển"
                  v-model="filterForm.transferDate"
                  @show-date-picker="showDate(4)"
                    :time-picker="true"
                  :timePicker24Hour="true"
                  :autoApply="false"
                  :defaultRange="{startDate: start, endDate: end}"
              ></common-range-time-picker>
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="filterForm.bankName"
                  :items="banks"
                  item-text="name"
                  item-value="name"
                  placeholder="Ngân hàng nhận"
                  clearable
                  hide-details
              />
            </v-col>
<!--            <v-col cols="12" md="6">-->
<!--              <v-autocomplete-->
<!--                  v-model="filterForm.transactionStatus"-->
<!--                  :items="TRANSACTION_STATUS_OPTIONS"-->
<!--                  item-text="name"-->
<!--                  item-value="id"-->
<!--                  placeholder="Trạng thái"-->
<!--                  clearable-->
<!--                  hide-details-->
<!--              />-->
<!--            </v-col>-->
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="filterForm.transferMethod"
                  :items="TRANSFER_METHOD_OPTIONS"
                  item-text="name"
                  item-value="name"
                  placeholder="Hình thức"
                  clearable
                  hide-details
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="filterForm.approvedBy"
                  :items="listApprovedBy"
                  item-text="name"
                  item-value="id"
                  placeholder="Phê duyệt bởi"
                  clearable
                  hide-details
              />
            </v-col>
            <v-col cols="12" md="6">
                  <v-autocomplete
                          v-model="filterForm.importingSource"
                          :items="listImportingSource"
                          item-text="name"
                          item-value="code"
                          placeholder="Nguồn"
                          clearable
                          hide-details
                  />
              </v-col>
          </v-row>
        </v-container>
        <div class="text-center mb-4">
          <v-btn class="grey lighten-1 mx-2" style="color: black" @click="closeMenu">
            Hủy
          </v-btn>
          <v-btn class="primary mx-2" @click="searchContact">
            <v-icon>mdi-magnify</v-icon>Tìm kiếm nâng cao
          </v-btn>
          <v-btn class="primary mx-2" @click="exportExcel" v-if="checkAuthorization('reconcile-sms_download')">
            <v-icon>mdi-download</v-icon>Download
          </v-btn>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
import moment from 'moment'
import RepositoryFactory from '@/repositories/RepositoryFactory';
import {subjectTest, TRANSACTION_STATUS_OPTIONS, TRANSFER_METHOD_OPTIONS} from '@/helpers/constants';
const OrderRepository = RepositoryFactory.get('order')
import TokenService from '@/helpers/token';
let start = new Date();
start.setHours(0,0,0,0);
let end = new Date();
end.setHours(23,59,59,999);
export default {
  name: 'StatusFilterForm',
  props: {
    filterForm: {
      default: () => ({})
    },
    banks: {
      default: () => []
    },
  },
  data () {
    return {
      currentPicker: null,
      showPopupDate: false,
      usersTemp: [],
      userPostion: TokenService.getPosition(),
      showContactedErrors: false,
      minDateContacted: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      typeSearch: [
        {
          label: 'Bằng',
          value: 'eq'
        }, {
          label: 'Lớn hơn',
          value: 'gt'
        }, {
          label: 'Nhỏ hơn',
          value: 'lt'
        }
      ],
      listImportingSource: [
          { code: "SAO_KE", name: 'Sao kê'},
          { code: "SMS", name: 'SMS'},
      ],
      socialValue:null,
      openTree: false,
      search: '',
      open: [1],
      allOpened: false,
      lastOpen: [],
      subjectTest,
      showCumulatedErrors: false,
      isMonthPicker: false,
      districtList: [],
      schoolList: [],
      TRANSACTION_STATUS_OPTIONS,
      TRANSFER_METHOD_OPTIONS,
      start: start,
      end: end,
      listApprovedBy:[],
    }
  },
  async created() {
    await this.getListApproveBy();
  },
  methods: {
    showDate(index) {
      this.currentPicker = index;
    },
    closeMenu() {
      this.filterForm.closeMenu = false
    },
    searchContact() {
      if (this.filterForm.isContacted && (!_.isArray(this.filterForm.contactedAt) || !this.filterForm.contactedAt.length)) {
        this.showContactedErrors = true
      } else if ((this.filterForm.monthPicker || this.filterForm.inputPointCumulated ) && (!this.filterForm.monthPicker ||  !this.filterForm.compare || !this.filterForm.inputPointCumulated)) {
        this.showCumulatedErrors = true;
      }
      else {
        this.showContactedErrors = false;
        this.showCumulatedErrors = false;
        Bus.$emit('contact-list-filter', this.filterForm);
      }
    },
    checkEmptyFilterForm() {
      switch(true) {
        case this.filterForm.transferDate[0]?.length > 0:
          return true
        default:
          return false
      }
    },
    async exportExcel() {
      if (!this.checkEmptyFilterForm()) {
        this.$swal({
          type: 'error',
          title: 'Thông báo !',
          text: 'Ngày giờ chuyển không được để trống',
        })
        return;
      }
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      const params = {
        username: user.username,
        keyword: this.filterForm.keyword?.trim(),
        transferMethod: this.filterForm.transferMethod,
        transactionStatus: this.filterForm.transactionStatus,
        bankName: this.filterForm.bankName,
        approvedBy: this.filterForm.approvedBy,
      };
      if(this.filterForm.transferDate?.length > 0){
        params.transferDate = `${moment(this.filterForm.transferDate[0]).format("YYYY/MM/DD  HH:mm:ss")}-${moment(this.filterForm.transferDate[1]).format("YYYY/MM/DD HH:mm:ss")}`
      }
      OrderRepository.exportExcelOrderPaymentChecklist(params);
      loader.hide();
      this.$swal({
        title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
      });
    },
    handleSearch: function (val) {
      if (val) {
        if (!this.allOpened) {
          this.lastOpen = this.open;
          this.allOpened = true;
          this.$refs.tree.updateAll(true);
        }
      } else {
        this.$refs.tree.updateAll(false);
        this.allOpened = false;
        this.open = this.lastOpen;
      }
    },
    removeNodeSelected() {
      this.filterForm.userIds = []
    },
    removeOrderSelected() {
      this.filterForm.orderCreatedBy = []
    },
    async getListApproveBy() {
      const res = await OrderRepository.getListApproveBy();
      if (res?.success){
        this.listApprovedBy = _.get(res, 'data', []);
      }
    }
  },
};
</script>
<style scoped>

  /deep/.hide-date .daterangepicker.dropdown-menu{
    display: none
  }
  /deep/.show-date .daterangepicker.dropdown-menu{
    display: block;
  }
  .tree-user-selected {
    height: 34px;
    overflow-y: auto;
    border-bottom: 1px solid #d2d2d2;
  }
  .menu-wrapper-tree-user {
    background: #FFFFFF !important;
  }
  .tree-view-wrapper {
    max-height: 350px;
    overflow-y: auto;
  }
  .icon-clear-all {
    position: absolute;
    right: 15px;
    top: 20px;
    background: white;
  }
  /deep/.v-subheader.theme--light {
    width: 100%;
    background: rgb(206, 150, 104);
  }
</style>
